import Header from '../components/Header';
import './Home.css';

function HeadacheNotePrivacy() {
  return (
    <div className="Home" id="headache-note-privacy">
      <Header />
      <main>
        <section className="Legal">
          <h1>頭痛ノート プライバシーポリシー</h1>

          <p>
            このプライバシーポリシー（以下、「本ポリシー」といいます。）は、本サービス運営者（以下、「運営者」といいます。）が提供する「頭痛記録アプリ」（以下、「本サービス」といいます。）におけるユーザーの個人情報の取扱いについて定めるものです。本サービスをご利用いただく前に、必ず本ポリシーをお読みください。
          </p>

          <h2>第1条（個人情報の定義）</h2>
          <p>
            本ポリシーにおける「個人情報」とは、個人情報保護法に定義される「個人情報」を指します。具体的には、氏名、住所、電話番号、メールアドレス、健康情報その他特定の個人を識別できる情報および他の情報と照合することにより特定の個人を識別できる情報を含みます。
          </p>
          <p>
            なお、本サービスでは、位置情報（緯度・経度等）および手動設定した地域に対応する緯度・経度（小数点以下4桁まで保持）等の情報（以下、総称して「位置情報等」といいます。）を取り扱う場合があります。位置情報等は、それ単体では個人情報に該当しない場合がありますが、他の情報と組み合わさることにより特定の個人を識別し得る場合には、個人情報として適切に取り扱います。
          </p>

          <h2>第2条（個人情報の収集方法）</h2>
          <p>運営者は、本サービスの提供に際して、以下の方法で個人情報を収集します。</p>
          <ul>
            <li>ユーザー登録時：メールアドレス、パスワードなどの登録情報</li>
            <li>
              本サービスの利用時：頭痛の発生日時、痛みの程度、症状の詳細、服薬状況、トリガー要因、メモ欄への記載内容などの健康情報、AIレポート機能の利用状況および、同機能で解析・生成の対象となる入力情報
            </li>
            <li>
              本サービスの利用時（位置情報等）：端末の許可設定に基づき取得される位置情報（緯度・経度、概ねの現在地情報等）、ユーザーが手動設定する地域（例：都道府県の県庁所在地等）に対応する緯度・経度（小数点以下4桁まで保持）および取得時刻・精度等の付随情報
            </li>
            <li>自動取得情報：アプリの利用履歴、アクセスログ、IPアドレス、端末情報、OS種別・バージョン、アプリバージョン等</li>
            <li>お問い合わせ時：メールアドレス、お問い合わせ内容等</li>
          </ul>

          <h2>第3条（個人情報の利用目的）</h2>
          <p>運営者は、収集した個人情報を以下の目的で利用します。</p>
          <ul>
            <li>本サービスの提供および運営のため</li>
            <li>本サービスにおけるユーザー登録、本人確認、認証のため</li>
            <li>本サービスのサブスクリプション機能の提供、利用状況の確認、利用料金の請求および決済手続のサポートのため</li>
            <li>天気情報等の提供のため（位置情報等に基づく天気情報の表示を含みます。）</li>
            <li>位置情報等に基づく機能提供のため（頭痛記録の振り返り・分析補助、分析・レコメンドの生成、通知の配信・最適化等を含みます。）</li>
          </ul>
          <p>
            なお、クレジットカード情報等の決済情報は、主として各アプリストア（Apple App
            Store、Google
            Playストア等）が管理し、運営者は当該情報の一部または全部にアクセスしない場合があります。
          </p>
          <ul>
            <li>AIレポート機能の提供のため</li>
            <li>利用者の入力した頭痛記録等の情報をもとに、LLM（大規模言語モデル）を用いてレポートやアドバイス風のテキストを生成するため</li>
            <li>ユーザーサポート（お問い合わせ対応、不具合対応等）のため</li>
            <li>本サービスの品質向上、新機能の開発、利用状況の分析のため</li>
          </ul>
          <p>この際、可能な限り個人を特定できない形に加工した統計情報として利用するよう努めます。</p>
          <p>利用規約・本ポリシーの変更、サービスに関する重要なお知らせ等を行うため</p>
          <p>法令で認められた場合を除き、上記の利用目的の範囲を超えて利用しません。</p>

          <h2>第4条（個人情報の第三者提供）</h2>
          <p>運営者は、次に定める場合を除き、あらかじめユーザーの同意を得ることなく個人情報を第三者に提供しません。</p>
          <ul>
            <li>法令に基づく場合</li>
            <li>人の生命、身体または財産の保護のために必要がある場合であって、ユーザー本人の同意を得ることが困難である場合</li>
            <li>公衆衛生の向上または児童の健全な育成の推進のため特に必要がある場合であって、ユーザー本人の同意を得ることが困難である場合</li>
            <li>
              国の機関もしくは地方公共団体またはその委託を受けた者が、法令の定める事務を遂行することに対して協力する必要がある場合であって、ユーザー本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがある場合
            </li>
            <li>その他、個人情報保護法その他の法令により第三者提供が認められる場合</li>
          </ul>
          <p>
            なお、後記のとおり、運営者が業務委託先に対して個人情報の取扱いを委託する場合は、個人情報保護法上の「第三者提供」には該当しません。
          </p>

          <h2>第5条（個人情報の取扱いの外部委託）</h2>
          <p>
            運営者は、本サービスの提供・運営・分析・AIレポート機能の提供等に必要な範囲で、個人情報の取扱いの一部を第三者に委託することがあります。
          </p>
          <p>委託先には、次のような事業者が含まれる場合があります。</p>
          <ul>
            <li>LLM（大規模言語モデル）提供事業者（例：OpenAI, L.L.C.）</li>
            <li>気象情報提供サービス事業者（例：OpenWeatherMap）</li>
            <li>通知配信基盤事業者（プッシュ通知等の配信に用いる事業者）</li>
            <li>クラウドインフラ事業者</li>
            <li>広告配信事業者</li>
            <li>アクセス解析・エラーログ解析ツールの提供事業者 等</li>
          </ul>
          <p>
            運営者は、委託先に対し、個人情報保護に関する契約等を締結するなど、適切な管理・監督を行い、委託先が本ポリシーおよび関係法令を遵守して個人情報を取り扱うよう努めます。
          </p>
          <p>
            AIレポート機能において利用者の入力情報を送信するLLM提供事業者に対しては、当該情報をAIレポート生成のための処理に限定して利用し、機械学習における汎用的な学習データとして利用しないよう求めます。
          </p>
          <p>
            また、天気情報の提供のため、気象情報提供サービス事業者に対し、天気情報の取得に必要な範囲で、位置情報等（または当該位置情報等に対応する情報）その他のリクエスト情報を送信することがあります。
          </p>

          <h2>第6条（AIレポート機能における個人情報の取扱い）</h2>
          <p>本サービスは、利用者が入力した頭痛記録等の情報をもとに、LLMを利用したAIレポート機能を提供する場合があります。</p>
          <p>AIレポート機能の提供に際しては、以下の取扱いを行います。</p>
          <ul>
            <li>
              利用者が入力した内容（頭痛の発生状況、症状、服薬、生活習慣、メモ欄の記載内容等）が、AIレポートを生成する目的のために、LLM提供事業者のサーバーに送信されます。
            </li>
          </ul>
          <p>運営者は、必要な範囲でのみ情報が送信されるよう努め、個人を直接特定し得る情報の送信を最小限に抑えるよう配慮します。</p>
          <p>
            運営者は、LLM提供事業者に対し、送信された情報をAIレポート機能の提供に必要な範囲に限定して利用し、汎用的な学習データとして利用しないよう求めます。
          </p>
          <p>
            運営者は、本サービスおよびAIレポート機能の品質向上のため、利用者の記録情報を統計的に集計・分析し、個人を特定できない形式に加工した上で、サービス改善・機能開発等に利用することがあります。
          </p>
          <p>
            利用者が自ら以外の第三者に関する情報（家族・知人等）を本サービスに入力する場合、利用者は当該第三者から必要な同意を取得したうえで入力するものとし、その結果について自己の責任を負うものとします。
          </p>

          <h2>第6条の2（位置情報等の取扱い）</h2>
          <p>
            本サービスは、天気情報の表示、頭痛記録の振り返り・分析補助、レコメンド、通知その他本サービスの機能提供のため、位置情報等を取得し、利用し、必要な範囲で運営者のサーバー上に保存する場合があります。
          </p>
          <ul>
            <li>端末の許可設定に基づき取得される位置情報（緯度・経度、概ねの現在地情報等）</li>
            <li>
              ユーザーが手動設定する地域（例：都道府県の県庁所在地等）に対応する緯度・経度（小数点以下4桁まで保持。仕様上、四捨五入その他の方法により当該桁数に丸めて保存される場合があります。）
            </li>
          </ul>
          <p>
            端末の位置情報の取得は、ユーザーが端末の権限設定により許可した範囲で行われます。ユーザーは、端末設定または本サービス内の設定により、いつでも位置情報の提供を停止または変更することができます。
          </p>
          <p>
            ユーザーは、本サービス内の機能または第13条のお問い合わせ窓口への連絡により、運営者のサーバー上に保存された位置情報等の削除を、任意のタイミングで求めることができます。運営者は、法令に従い、合理的な範囲で対応します。なお、削除の反映には合理的な範囲で時間を要する場合があります。
          </p>
          <p>
            本サービスは、天気情報の提供のため、OpenWeatherMap 等の気象情報提供サービスを利用します。この際、天気情報の取得に必要な範囲で、位置情報等（または当該位置情報等に対応する情報）その他のリクエスト情報が当該サービス提供者に送信される場合があります。
          </p>

          <h2>第7条（個人情報の安全管理）</h2>
          <p>運営者は、個人情報の漏洩、滅失、毀損等を防止するため、適切な安全管理措置を講じます。</p>
          <p>具体的には、以下の対策を実施しています。</p>
          <ul>
            <li>個人情報へのアクセス制限（アクセス権限の管理）</li>
            <li>通信経路および保存データの暗号化</li>
            <li>アプリおよびサーバーの定期的なセキュリティチェック・アップデート</li>
            <li>委託先に対する契約・監督等の適切な管理</li>
          </ul>
          <p>
            万が一、個人情報の漏洩等の事態が発生した場合には、関係法令およびガイドラインに従い、速やかに原因究明・影響範囲の特定・再発防止策の実施等を行います。
          </p>

          <h2>第8条（個人情報の保存期間）</h2>
          <p>運営者は、個人情報を、収集目的の達成に必要な期間の範囲内でのみ保存します。</p>
          <p>
            目的が達成された後、またはユーザーから削除の要請があり、かつ運営者が当該要請に応じる必要があると判断した場合には、速やかに削除または匿名化するよう努めます。
          </p>
          <p>
            ただし、法令に基づき一定期間の保存が義務付けられている場合、または紛争対応等のために保存が必要な場合は、この限りではありません。
          </p>

          <h2>第9条（ユーザーの権利）</h2>
          <p>ユーザーは、自己の個人情報について、個人情報保護法その他の法令に基づき、以下の権利を有します。</p>
          <ul>
            <li>開示請求：保有する個人情報の内容の開示を求める権利</li>
            <li>訂正請求：個人情報の内容に誤りがある場合、訂正・追加・削除を求める権利</li>
            <li>利用停止等請求：個人情報の利用の停止または消去を求める権利</li>
            <li>第三者提供の停止請求：第三者への提供の停止を求める権利</li>
          </ul>
          <p>
            これらの権利を行使する場合は、下記の「お問い合わせ先」にご連絡ください。運営者は、法令に従い、合理的な範囲および期間で対応します。ただし、法令上運営者に義務がない場合や、運営者の業務遂行に著しい支障をきたすおそれがある場合等には、ご要望に沿えないことがあります。
          </p>
          <p>
            位置情報等の削除については、本サービス内の機能またはお問い合わせにより行うことができます。
          </p>

          <h2>第10条（国外へのデータ移転）</h2>
          <p>
            本サービスに関連して、LLM提供事業者やクラウドサービス事業者等、国外に所在する事業者のサーバーに個人情報が保存され、または処理される場合があります。
          </p>
          <p>
            この場合、運営者は、当該事業者が所在する国または地域の個人情報保護に関する制度を確認しつつ、適切な契約等の手段により、個人情報が本ポリシーおよび関係法令に従って保護されるよう努めます。
          </p>

          <h2>第11条（使用ツール）</h2>
          <p>
            本サービスでは、広告配信ツールとしてGoogle
            AdMobを使用しています。当該ツールが利用者の情報を自動取得する場合がございます。取得する情報、利用目的、第三者への提供等につきましては、広告配信事業者のプライバシーポリシーをご確認ください。
          </p>
          <p>
            AdMob（Google Inc.）：
            <a href="https://policies.google.com/technologies/ads?hl=ja" target="_blank" rel="noopener noreferrer">
              https://policies.google.com/technologies/ads?hl=ja
            </a>
          </p>
          <p>
            本サービスでは、天気情報の提供のため、OpenWeatherMap 等の気象情報提供サービスを利用する場合があります。当該サービスに対しては、天気情報の取得に必要な範囲で、位置情報等（または当該位置情報等に対応する情報）その他のリクエスト情報が送信される場合があります。
          </p>
          <p>
            このほか、本サービスの利用状況の把握や品質向上のため、アクセス解析ツールやクラッシュレポートツール等を利用する場合があります。その場合には、必要に応じて本ポリシーの改定またはアプリ内での告知を行います。
          </p>

          <h2>第12条（プライバシーポリシーの変更）</h2>
          <p>運営者は、必要と判断した場合には、ユーザーに通知することなく本ポリシーを変更することがあります。</p>
          <p>変更後の本ポリシーは、本サービス上に掲載された時点から効力を生じます。</p>
          <p>本ポリシーに重要な変更がある場合は、アプリ内での表示その他の適切な方法によりユーザーに通知します。</p>

          <h2>第13条（お問い合わせ）</h2>
          <p>ユーザーの個人情報に関するお問い合わせや、ユーザーが自身の個人情報に関する権利を行使する場合は、以下の方法でご連絡ください。</p>
          <p>メールアドレス：support@ystudiox.com</p>

          <p>制定日：2025年3月3日</p>
          <p>改定日：2026年1月14日</p>
        </section>
      </main>
      <footer className="SiteFooter">
        <small>© {new Date().getFullYear()} YStudioX</small>
      </footer>
    </div>
  );
}

export default HeadacheNotePrivacy;


